import * as React from 'react';
import { ArticleHeading4 } from '@cian/ui-kit';
import { IconActionClose16, IconMapPin16, IconFunctionalClock16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './OfficeCard.css';

interface IOfficeCardProps {
  image: React.ReactNode;
  close?: React.ReactNode;
  title: React.ReactNode;
  address: React.ReactNode;
  workingTime: React.ReactNode;
  subwayInfo: React.ReactNode;
  contacts?: React.ReactNode;
  hasClose: boolean;
}

export function OfficeCard({
  hasClose,
  image,
  title,
  address,
  workingTime,
  subwayInfo,
  contacts,
  close = <IconActionClose16 color="white_100" />,
}: IOfficeCardProps) {
  return (
    <article className={styles['card']}>
      {hasClose && (
        <span id="close" className={styles['card__close']}>
          {close}
        </span>
      )}

      <div className={styles['card__image']}>{image}</div>

      <div className={styles['card__body']}>
        <div className={styles['card__body-item']}>
          <ArticleHeading4>Офис продаж</ArticleHeading4>
        </div>
        <div className={styles['card__body-item']}>{title}</div>
        <div className={styles['card__body-item']}>
          <span className={styles['card__body-icon']}>
            <IconMapPin16 />
          </span>
          {address}
        </div>
        {workingTime && (
          <div className={styles['card__body-item']}>
            <span className={styles['card__body-icon']}>
              <IconFunctionalClock16 />
            </span>
            {workingTime}
          </div>
        )}
        <div className={styles['card__body-item']}>{subwayInfo}</div>

        {contacts && <div className={styles['card__contacts']}>{contacts}</div>}
      </div>
    </article>
  );
}
